import type { OperationModel } from '@app/models/api/OperationModel';
import { getOperation } from '@app/services/api/operations';
import { error, redirect } from '@sveltejs/kit';
import { urls } from '@app/urls';
import { operationStore } from '@app/stores/operation';
import { signInUpModalStore } from '@app/stores/signInUpModal';

export const load = async ({ parent, params, fetch, url }) => {
	let operation: OperationModel;
	let { slug } = params;
	let [id, tab] = slug.split('/');

	const data = await parent();
	const hasAccess = url.searchParams.get('hasAccess');

	// si l'ID de l'opé dans l'URL contient autre chose qu'un nombre
	if (!/^\d+$/.test(id)) error(404);

	try {
		operation = await getOperation(id, null, fetch);
		operationStore.set(operation);
	} catch (e) {
		if (e.httpStatus === 404) {
			if (hasAccess === 'true' && !data.user) {
				signInUpModalStore.open({ isOpenFromProtectedRoute: true });
			} else {
				redirect(301, urls.PROJECT.PRIVATE_ACCESS);
			}
		} else {
			error(e?.httpStatus, e?.message);
		}
	}

	return { id, tab, operation };
};
